export const roles = {
  SUPER_ADMIN: "Super Admin",
  ACCOUNT_OWNER: "Account Owner",
  ACCOUNT_ADMIN: "Account Admin",
  FARM_EMPLOYEE: "Farm Employee"
};

export const subscriptionPlan = [
  { name: "Basic", id: "1" },
  { name: "Basic Plus", id: "2" },
  { name: "Enterprise", id: "3" },
  { name: "Enterprise Plus", id: "4" }
];



// WEBPACK FOOTER //
// ./src/constants/UserAttributes.js